/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
/// <reference path="../filters/currencyFilter.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoPercentageCurrencyToggle implements angular.IDirective {
        restrict = "E";
        scope = {
            currentValue: "=ngModel",
            contentKey: "@?",
            disabled: "=?ngDisabled",
            required: "=?ngRequired",
            backgroundColor: "=?",
            onPostBlur: "&?",
            isPercent: "=",
            displayRight: "=?",
            decimalMaskPercentage: "=?",
            decimalMaskCurrency: "=?",
            maxValuePercentage: '=?',
            maxValueCurrency: '=?',
            maxValueValidation: "=?",
            tabIndex: '=?',
            name: '@?',
            disableSwitch: "<?",
            onCurrencyToggle: "&?",
            allowNegatives: "=?",
            zeroInvalid: "=?",
            showDecimalMaskForZero: "=?",
        };

        templateUrl = "app/components/controls/percentageCurrencyToggleTemplate.html";

        link = (scope: any, element: JQuery, attrs: angular.IAttributes) => {
            //  Initialize Max Values and Mask
            var oldCurrentVal;
            if (angular.isUndefined(scope.maxValuePercentage))
                scope.maxValuePercentage = 9999999.99;
            if (angular.isUndefined(scope.decimalMaskPercentage))
                scope.decimalMaskPercentage = 4;
            if (angular.isUndefined(scope.maxValueCurrency))
                scope.maxValueCurrency = 999999999.99;
            if (angular.isUndefined(scope.decimalMaskCurrency))
                scope.decimalMaskCurrency = 2;
            if (angular.isUndefined(scope.disableSwitch))
                scope.disableSwitch = false;

            scope.tabIndex = scope.tabIndex || 0;
            scope.currency = this.appSettings.APP_CURRENCY;
            //  Defaults to display the button to the left
            scope.displayRight = false;

            scope.onBlur = () => {
                if (_.isFunction(scope.onPostBlur)) {
                    scope.onPostBlur();
                }
            };


            //  Parse currentValue
            scope.parseValues = () => {
                if (scope.isPercent) {
                    scope.currentValuePercentage = parseFloat((parseFloat(scope.currentValueCurrency) / 100).toFixed(scope.decimalMaskPercentage + 2));
                    scope.currentValue = scope.currentValuePercentage;
                    //  TODO: What displayValuePercentage Does??
                    //  scope.displayValuePercentage = parseFloat((parseFloat(scope.currentValue)).toFixed(scope.decimalMaskPercentage + 2)) + "%";
                } else {
                    scope.currentValueCurrency = parseFloat((parseFloat(scope.currentValuePercentage) * 100).toFixed(scope.decimalMaskCurrency + 2));
                    scope.currentValue = scope.currentValueCurrency;
                }
            }
            //reassign values
            scope.reassignValues = () => {
                if (scope.isPercent) {
                    scope.currentValue = scope.currentValuePercentage;
                } else {
                    scope.currentValue = scope.currentValueCurrency;
                }
            }
            //added watch, to ensure the original value is visible in the UI on click of undo
            //bug 57631
            var deregWatchPercentageValue = null;
            scope.initializeWatchCurrValue = () => {
                if (deregWatchPercentageValue == null) {
                    deregWatchPercentageValue = scope.$watch("currentValue", function (newVal, oldVal, currScope) {

                        oldCurrentVal = newVal;
                        if (scope.isPercent) {
                            scope.currentValuePercentage = oldCurrentVal;
                        }
                        else { scope.currentValueCurrency = oldCurrentVal;}
                        scope.reassignValues();

                    });
                }
            };
            scope.initializeWatchCurrValue();

            if (scope.isPercent) {
                scope.currentValuePercentage = scope.currentValuePercentage || scope.currentValue;
            } else {
                scope.currentValueCurrency = scope.currentValueCurrency || scope.currentValue;
            }

            scope.toggleInputType = () => {
                if (scope.disabled || scope.disableSwitch)
                    return false;
                scope.isPercent = !scope.isPercent;
                scope.parseValues();

                if (_.isFunction(scope.onCurrencyToggle)) {
                    scope.onCurrencyToggle();
                }
            };

            scope.$watch('currentValuePercentage', function (newVal, oldVal) {
                if (scope.isPercent) {
                    scope.currentValue = scope.currentValuePercentage;
                }
            })

            scope.$watch('currentValueCurrency', function (newVal, oldVal) {
                if (!scope.isPercent) {
                    scope.currentValue = scope.currentValueCurrency;
                }
            })

        };

        constructor(private appSettings: Meevo.Components.Common.IAppSettings) {

        }

        static factory(): angular.IDirectiveFactory {
            let directive = (appSettings: Meevo.Components.Common.IAppSettings) => {
                return new MeevoPercentageCurrencyToggle(appSettings);
            };
            directive.$inject = ["meevo.AppSettings"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoPercentageCurrencyToggle", MeevoPercentageCurrencyToggle.factory());
}
